import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { IUserDesign } from "@/types/user.types";
import { IDesignType } from "@/types/stateTypes";
import { ICustomLogo, ISavedDesigns } from "@/types/all.types";

export const useDesignType = create<IDesignType>((set) => ({
  designType: "Sticker",
  setDesignType: (val) => set((state) => ({ ...state, designType: val })),
}));

export const useUserDesign = create<IUserDesign>((set) => ({
  qrShape: "",
  sticker: "",
  stickerParams: {
    stickerColor: "#000000",
    stickerText: "SCAN ME",
  },
  color: {
    backcolor: "#ffffff",
    frontcolor: "#000000",
  },
  markersAndColor: {
    marker_top_left: {
      marker: "default",
      outer_color: "#000000",
      inner_color: "#000000",
    },
    marker_top_right: {
      marker: "default",
      outer_color: "#000000",
      inner_color: "#000000",
    },
    marker_bottom: {
      marker: "default",
      outer_color: "#000000",
      inner_color: "#000000",
    },
  },
  shape: {
    body_type: "default",
    edges: "default",
  },
  logo: {
    upload_logo: "none",
    scale_logo: 40,
    scale_logo_background: 0,
  },
  decorate: {},
  arrived: false,
  setSticker: (val) => set((state) => ({ ...state, sticker: val })),
  setStickerParams: (val) =>
    set((state) => {
      return {
        ...state,
        stickerParams: {
          ...state.stickerParams,
          ...val,
        },
      };
    }),
  setQrShape: (val) => set((state) => ({ ...state, qrShape: val })),
  setMarkersColor: (val) =>
    set((state) => {
      return {
        ...state,
        markersAndColor: {
          ...state.markersAndColor,
          marker_bottom: {
            ...state.markersAndColor?.marker_bottom,
            ...val,
          },
          marker_top_left: {
            ...state.markersAndColor?.marker_top_left,
            ...val,
          },
          marker_top_right: {
            ...state.markersAndColor?.marker_top_right,
            ...val,
          },
        },
      };
    }),
  setMarkerColorTopLeft: (val) =>
    set((state) => {
      return {
        ...state,
        markersAndColor: {
          ...state.markersAndColor,
          marker_top_left: {
            ...state.markersAndColor?.marker_top_left,
            ...val,
          },
        },
      };
    }),
  setMarkerColorTopRight: (val) =>
    set((state) => {
      return {
        ...state,
        markersAndColor: {
          ...state.markersAndColor,
          marker_top_right: {
            ...state.markersAndColor?.marker_top_right,
            ...val,
          },
        },
      };
    }),
  setMarkerColorBottom: (val) =>
    set((state) => {
      return {
        ...state,
        markersAndColor: {
          ...state.markersAndColor,
          marker_bottom: {
            ...state.markersAndColor?.marker_bottom,
            ...val,
          },
        },
      };
    }),
  setColor: (val) => set((state) => ({ ...state, color: { ...state.color, ...val } })),
  setMarkersAndColorAll: (val) =>
    set((state) => ({
      ...state,
      markersAndColor: val,
    })),
  setArrived: (val) => set((state) => ({ ...state, arrived: val })),
  setShape: (val) => set((state) => ({ ...state, shape: { ...state.shape, ...val } })),
  setLogo: (val) => set((state) => ({ ...state, logo: { ...state.logo, ...val } })),
  destroyUserDesign: () =>
    set((state) => ({
      ...state,
      markersAndColor: {
        marker_top_left: {
          marker: "default",
          outer_color: "#000000",
          inner_color: "#000000",
        },
        marker_top_right: {
          marker: "default",
          outer_color: "#000000",
          inner_color: "#000000",
        },
        marker_bottom: {
          marker: "default",
          outer_color: "#000000",
          inner_color: "#000000",
        },
      },
      qrShape: "",
      sticker: "",
      stickerParams: {
        stickerColor: "#000000",
        stickerText: "",
      },
      color: {
        backcolor: "#ffffff",
        frontcolor: "#000000",
        marker_in_color: "#000000",
        marker_out_color: "#000000",
      },
      shape: {
        body_type: "default",
        edges: "default",
      },
      logo: {
        upload_logo: "",
        scale_logo: 80,
        scale_logo_background: 0,
      },
      decorate: {},
      arrived: false,
    })),
  setDeleteKey: (val) =>
    set((state) => {
      delete state[val as keyof typeof state];

      return { ...state };
    }),
}));

export const useSavedDesigns = create<ISavedDesigns>((set) => ({
  isSavedDesigns: false,
  setIsSavedDesigns: (val) => {
    set({
      isSavedDesigns: val,
    });
  },
}));

export const useCustomLogo = create<ICustomLogo>((set) => ({
  customLogo: { logo: null, name: "" },
  setCustomLogo: (val) => set((state) => ({ customLogo: { ...state.customLogo, ...val } })),
}));
